module.exports = __webpack_public_path__ + "img/icon_4_36.e7e9e321.png";